import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  digitalizationsController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    'digitalizationService',
    '$filter',
    '$state',
    '$controller',
    'EQuickAccessItems',
    '$interval',
    '$timeout',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      digitalizationService,
      $filter,
      $state,
      $controller,
      EQuickAccessItems,
      $interval,
      $timeout
    ) {
      'use strict';

      let loadingStartTime = null;

      var EDigitalizationTab = {
        PROCESSING: 1,
        PENDING: 2,
        COMPLETED: 3,
      };

      function defaultTabs() {
        return [
          { id: EDigitalizationTab.PROCESSING, label: 'Em Processamento', count: 0 },
          { id: EDigitalizationTab.PENDING, label: 'Pendentes', count: 0 },
          { id: EDigitalizationTab.COMPLETED, label: 'Classificação concluída', count: 0 },
        ];
      }

      function loadTabCounts() {
        digitalizationService.getTabCounts().then(
          function (data) {
            $scope.tabs.forEach(function (tab) {
              if (tab.id === EDigitalizationTab.PENDING)
                tab.count = data.Pending || data.pending || 0;
              if (tab.id === EDigitalizationTab.PROCESSING)
                tab.count = data.Processing || data.processing || 0;
              if (tab.id === EDigitalizationTab.COMPLETED)
                tab.count = data.Completed || data.completed || 0;
            });
          },
          function () {
            // API ainda não existe: não derruba a tela
          }
        );
      }

      function parseClassified(doc) {
        var raw = (doc && (doc.description || doc.Description)) || '';

        var folderName =
          doc &&
            doc.folder &&
            (doc.folder.Name || doc.folder.name)
            ? (doc.folder.Name || doc.folder.name)
            : '';

        if (!raw || raw.indexOf('CLASSIFIED:') !== 0) {
          return {
            idFolder: Number(doc.idFolder) || 0,
            idDocumentType: 0,
            classification: '',
            folderName: folderName
          };
        }

        var parts = raw.split(':');

        return {
          idFolder: Number(doc.idFolder) || Number(parts[1]) || 0,
          idDocumentType: Number(parts[2]) || 0,
          classification: parts.slice(3).join(':') || '',
          folderName: folderName
        };
      }

      function getClassifiedInfo(doc) {
        return parseClassified(doc);
      }

      function goToClassifiedFolder(doc) {
        var folderId = Number(doc.idFolder) || 0;
        if (!folderId || folderId <= 0) {
          // fallback se description CLASSIFIED: ainda existir
          var info = parseClassified(doc);
          folderId = info.idFolder;
        }
        if (!folderId || folderId <= 0) return;

        // id da revisão na pasta (API Completed já manda Id = IdRevision)
        var revisionId = doc.id;
        if (!revisionId) return;

        $rootScope.selectRevisionAfterLoad = revisionId;

        $timeout(function () {
          $state.go('home.folder', { id: folderId, page: 1 });
          $rootScope.$broadcast('loadFolder', folderId);
        }, 0);
      }

      function selectTab(tab) {
        var id = typeof tab === 'object' ? tab.id : tab;

        if (id !== EDigitalizationTab.PENDING) {
          $scope.isPreviewOpen = false;
          $scope.currentDocument = null;

          if (typeof $scope.updateColumnsForPreview === 'function') {
            $scope.updateColumnsForPreview();
          }
        }

        $scope.activeTab = id;
        $scope.currentPage = 1;
        $scope.loadDocuments();
      }

      // eslint-disable-next-line no-unused-vars
      function itemsFilter(item) {
        return true;//item.idStatus === EDocumentStatus.IN_CHECKOUT;
      }

      function goToPage(page) {
        $state.go('home.digitalizations', { page: page });
      }

      function loadDocuments(isAutoRefresh = false) {
        if ($scope.currentPage < 1) {
          $scope.goToPage(1);
        } else {
          $rootScope.currentDocument = null;

          loadTabCounts();

          $scope.count = 0;
          $scope.description = 'LOADING DOCUMENTS';
          $scope.documents(null);

          if (isAutoRefresh) {
            $scope.refreshing = true;
          } else {
            $scope.loading = true;
          }

          $scope.showOverlay = true;
          loadingStartTime = new Date().getTime();

          var folderColumn = $scope.columns.filter((c) => c.id === 'folder')[0];
          if (folderColumn !== undefined && folderColumn !== null)
            folderColumn.disabled = false;

          digitalizationService.cancelLoadDigitalizations();
          $rootScope.$broadcast('loadFolder', EQuickAccessItems.DIGITALIZATIONS);

          digitalizationService
            .loadDigitalizations($scope.currentPage, $scope.pageSize, $scope.activeTab)
            .then(
              function (data) {
                $scope.count = data.length;
                $scope.totalItem = $scope.count;

                if ($scope.totalItem > $scope.limite) {
                  $scope.limiteValor = $scope.limite;
                  $scope.botaoAtivo = true; //Mostra o botão caso necessario
                } else {
                  $scope.limiteValor = $scope.totalItem;
                  $scope.botaoAtivo = false;
                }

                $scope.pageCount = Math.ceil($scope.count / $scope.pageSize);
                $scope.loading = false;

                if ($scope.pageCount < $scope.currentPage && $scope.count > 0) {
                  $scope.goToPage($scope.pageCount);
                } else {
                  $scope.documents(data);
                  $scope.groups = [];

                  $scope.description = $scope.getDescription(
                    $scope.currentPage,
                    $scope.pageSize,
                    $scope.count
                  );

                  var title = $scope.columns.filter(function (c) {
                    return c.id === 'title';
                  })[0];
                  title.sorted = '';
                  $scope.sortColumn(title);

                  finishLoading();
                }
              },
              function (data) {
                // jscs:disable requireCamelCaseOrUpperCaseIdentifiers

                if (
                  data.status_code === 500 &&
                  $scope.selectedTreeItem.Name === 'CHECKOUTS'
                ) {
                  $scope.documents([]);
                  return;
                }
                swal.fire(data.error, data.error_description);
                // jscs:enable requireCamelCaseOrUpperCaseIdentifiers
                finishLoading();
              }
            );
        }
      }

      function configColumnsEx() {
        $scope.columns = [
          {
            id: 'title',
            width: $scope.isAutologin() ? '10%' : '15%',
            header: $filter('translate')('COLUMN.NAME'),
            expression: 'formatedTitle()',
            style: {
              'min-width': '5px',
            },
            sortExpression: 'title',
            tooltip: 'tooltipTitle()',
            dataPriority: 1,
            visible: true,
            disabled: false,
            sortable: true,
            type: 'text',
          },
          {
            id: 'author',
            header: $filter('translate')('COLUMN.AUTHOR'),
            expression: 'author.Name',
            style: {
              'min-width': '60px',
            },
            width: '10%',
            mobileShow: false,
            visible: true,
            dataPriority: 6,
            disabled: false,
            sortable: true,
            type: 'text',
          },
          {
            id: 'date',
            header: $filter('translate')('COLUMN.DATE'),
            expression: 'formatedDate()',
            sortExpression: 'date',
            style: {
              'min-width': '75px',
            },
            width: '8%',
            mobileShow: false,
            visible: true,
            dataPriority: 5,
            disabled: false,
            sortable: true,
            type: 'date',
          },
          {
            id: 'size',
            header: $filter('translate')('COLUMN.SIZE'),
            expression: 'formatedSize()',
            sortExpression: 'size',
            style: {
              'min-width': '100px',
            },
            width: '6%',
            mobileShow: false,
            visible: true,
            dataPriority: 6,
            disabled: false,
            sortable: true,
            type: 'number',
          },
          {
            id: 'status',
            width: '25%',
            header: 'Status',
            expression: 'getDigitalizationStatus()',
            style: {
              'min-width': '120px',
            },
            dataPriority: 1,
            hideHeader: false,
            visible: true,
            disabled: false,
          },
        ];
      }

      let intervalPromise = null;
      let isLoadingAutoRefresh = false;

      function startAutoRefresh() {
        if (intervalPromise) return;

        intervalPromise = $interval(async () => {
          if (isLoadingAutoRefresh) return;

          isLoadingAutoRefresh = true;

          try {
            await $scope.loadDocuments(true);
          } finally {
            isLoadingAutoRefresh = false;
          }
        }, 10000);
      }

      function stopAutoRefresh() {
        if (intervalPromise) {
          $interval.cancel(intervalPromise);
          intervalPromise = null;
        }
      }

      $scope.$on('$destroy', function () {
        if (intervalPromise) {
          $interval.cancel(intervalPromise);
          intervalPromise = null;
        }
      });

      $scope.$on('STOP_AUTO_REFRESH', function () {
        stopAutoRefresh();
      });

      $scope.$on('RESUME_AUTO_REFRESH', function () {
        startAutoRefresh();
        $scope.loadDocuments();
      });

      $scope.$on('RELOAD_DIGITALIZATIONS', function () {
        $scope.loadDocuments();
      });

      function finishLoading() {
        const EXTRA_TIME = 2000;

        setTimeout(() => {
          $scope.loading = false;
          $scope.refreshing = false;
          $scope.showOverlay = false;

          if (loadingStartTime) {
            loadingStartTime = null;
          }

          if (!$scope.$$phase) {
            $scope.$applyAsync();
          }
        }, EXTRA_TIME);
      }

      function openClassifyFromStatus(event) {
        var el = event && event.target ? event.target.closest('.js-classify-pending') : null;
        if (!el) return;

        event.preventDefault();
        event.stopPropagation();

        var id = Number(el.getAttribute('data-doc-id'));
        if (!id) return;

        var docs = ($scope.revisionListService && $scope.revisionListService.documents) || [];
        var doc = docs.filter(function (d) {
          return d.id === id;
        })[0];
        if (!doc) return;

        // seleciona só este documento
        docs.forEach(function (d) {
          d.selected = false;
        });
        doc.selected = true;
        $rootScope.currentDocument = doc;

        if (typeof doc.properties === 'function') {
          doc.properties();
          $scope.$broadcast('STOP_AUTO_REFRESH');
        } else if (typeof $scope.properties === 'function') {
          $scope.properties();
          $scope.$broadcast('STOP_AUTO_REFRESH');
        }
      }

      function run() {
        try {
          $controller('baseController', { $scope: $scope });
          $controller('chatbotController', { $scope: $scope });

          $scope.loading = false;
          $scope.refreshing = false;
          $scope.showOverlay = false;

          $rootScope.$broadcast('clearSearchTerm');
          $scope.autologincolumns = ['icon', 'title', 'description'];
          $scope.title = $filter('translate')('PROCESSING');
          $scope.titleIsAI = true;
          $scope.description = '';
          $scope.noDocuments = $filter('translate')('NO PROCESSING');
          $scope.noDocumentsMessage = $filter('translate')('NO PROCESSING MSG');

          if (!$state.params.page) {
            $state.go('home.digitalizations', { page: 1 });
          }

          $scope.currentPage = $state.params.page
            ? parseInt($state.params.page)
            : 1;

          $scope.pageSize = 100;
          $scope.tabs = defaultTabs();
          $scope.EDigitalizationTab = EDigitalizationTab;
          $scope.activeTab = EDigitalizationTab.PROCESSING;
          $scope.pageCount = 1;
          $scope.groups = null;
          $scope.currentGroup = null;
          $scope.columns = [];
          $scope.canView = false;
          $scope.loading = true;
          $scope.count = 0;
          $scope.valueCanSendByEmail = false;
          $scope.checkCanSendByEmail = true;

          $scope.getClassifiedInfo = logWrapper(
            getClassifiedInfo,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectTab = logWrapper(
            selectTab,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.parseClassified = logWrapper(
            parseClassified,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.finishLoading = logWrapper(
            finishLoading,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.openClassifyFromStatus = logWrapper(
            openClassifyFromStatus,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.goToClassifiedFolder = logWrapper(
            goToClassifiedFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.itemsFilter = logWrapper(
            itemsFilter,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.goToPage = logWrapper(
            goToPage,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadDocuments = logWrapper(
            loadDocuments,
            runtimeConstant.isDebugControllersInternals
          );

          configColumnsEx();
          startAutoRefresh();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
